import QuickLinkModal from './QuickLinkModal';
export default QuickLinkModal;
